import Gen4Awards from "./gen4Awards";

export default Gen4Awards;
